module.exports = __webpack_public_path__ + "static/media/interview (2).93d6a41a.jpg";